import { useCopyToClipboard } from 'usehooks-ts';

// Vote type definition for stateless mode
type Vote = {
  messageId: string;
  type: 'up' | 'down';
};

import { CopyIcon } from './icons';
import { Actions, Action } from './elements/actions';
import { memo } from 'react';
import equal from 'fast-deep-equal';
import { toast } from 'sonner';
import type { ChatMessage } from '@/lib/types';

export function PureMessageActions({
  chatId,
  message,
  vote,
  isLoading,
  setMode,
}: {
  chatId: string;
  message: ChatMessage;
  vote: Vote | undefined;
  isLoading: boolean;
  setMode?: (mode: 'view' | 'edit') => void;
}) {
  const [_, copyToClipboard] = useCopyToClipboard();

  if (isLoading) return null;

  const textFromParts = message.parts
    ?.filter((part) => part.type === 'text')
    .map((part) => part.text)
    .join('\n')
    .trim();

  const handleCopy = async () => {
    if (!textFromParts) {
      toast.error("Il n'y a pas de texte à copier !");
      return;
    }

    await copyToClipboard(textFromParts);
    toast.success('Copié dans le presse-papiers !');
  };

  // Simplified actions - only copy for both user and assistant messages
  return (
    <Actions className={message.role === 'user' ? "-mr-0.5 justify-end" : "-ml-0.5"}>
      <Action tooltip="Copier" onClick={handleCopy}>
        <CopyIcon />
      </Action>
    </Actions>
  );
}

export const MessageActions = memo(
  PureMessageActions,
  (prevProps, nextProps) => {
    if (!equal(prevProps.vote, nextProps.vote)) return false;
    if (prevProps.isLoading !== nextProps.isLoading) return false;

    return true;
  },
);
